import axiosInstance from "./axiosInstance";

export const esignToolApi = {
    // get pdfeditor details

    signupSendOtp: async (email) => {
      const response = await axiosInstance.post(
          `/EsignServices/SendOtp`,
          { email }
      );
      return response.data;
    },

    signupVerifyOtp: async (email, otp) => {
      const response = await axiosInstance.post(
          `/EsignServices/verify_otp`,
          { email, otp }
      );
      return response.data;
    },

    sendFeedback: async (body) => {
      const response = await axiosInstance.post(
          `/EsignServices/send_feedback`,
          body
      );
      return response.data;
    },

    login: async (username) => {
        const response = await axiosInstance.post(
            `/EsignServices/get_pdf_editor_details`,
            { username }
        );
        return response.data;
    },

    sendOtpForgotPassword: async (email) => {
        const response = await axiosInstance.post(
            `/EsignServices/NewSendOtpForgetPassword`,
            { email }
        );
        return response.data;
    },

    updatePassword: async (body) => {
        const response = await axiosInstance.post(
            `/EsignServices/ChangePassword`,
            body
        );
        return response.data;
    },

    verifyOtp: async (email, otp) => {
        const response = await axiosInstance.post(
            `/EsignServices/NewVerifyOtpForgetPassword`,
            { email, otp }
        );
        return response.data;
    },

    setNewPassword: async (email, new_password, otp) => {
        const response = await axiosInstance.post(
            `/EsignServices/NewSetPasswordForgetPassword`,
            { email, new_password, otp }
        );
        return response.data;
    },

    lineChartData: async () => {
      const response = await axiosInstance.post(
          `/EsignServices/EsignLogCountLastSixMonth`,
          { }
      );
      return response.data;
    },

    // save signer details
    saveManualSigner: async (signerData, templateId, token) => {
      const response = await axiosInstance.post(
        `/EsignServices/SaveEditDeleteSigner`,
        { ...signerData,
          document_id: templateId,
         },
        { 
        }
      );
      return response.data;
    },

    updateManualSigner: async (signerData, templateId, token) => {
      const response = await axiosInstance.put(
        `/EsignServices/SaveEditDeleteSigner`,
        { ...signerData,
          document_id: templateId,
         },
        { 
        }
      );
      return response.data;
    },

    
    deleteManualSigner: async (signerID) => {
      const response = await axiosInstance.delete(
        `/EsignServices/SaveEditDeleteSigner`,
        {
          data: { id: signerID },
        },
      );
      return response;
    },

    deleteMultipleSigners: async (payload) => {
      const response = await axiosInstance.post(
        `/EsignServices/DeleteSignersAndReorderAPIView`,
        payload,
      );
      return response;
    },

    changeSequenceOfSigner: async (payload) => {
      const response = await axiosInstance.post(
        `/EsignServices/ChangeSequenceOfSigner`,
        payload,
      );
      return response;
    },

    updateEsignType: async (payload) => {
      const response = await axiosInstance.post(
        `/EsignServices/UpdateEsignTypeAPIView`,
        payload,
      );
      return response;
    },

    updateFrequentSigner: async (signerData) => {
      const response = await axiosInstance.put(
        `/EsignServices/AddEditDeleteFrequentSigner`,
        { ...signerData,
         },
        { 
        }
      );
      return response.data;
    },

    addFrequentSigner: async (signerData) => {
      const response = await axiosInstance.post(
        `/EsignServices/AddEditDeleteFrequentSigner`,
        { ...signerData,
         },
        { 
        }
      );
      return response.data;
    },

    getTemplateAndAutoReminderData: async (body) => {
      const response = await axiosInstance.post(
        `/EsignServices/GetTemplateAndAutoReminderData`,
        body,
        {},
      );
      return response.data;
    },

    // fetch saved signer details
    fetchManualSigner: async (templateId) => {
      const response = await axiosInstance.get(
        `/EsignServices/SaveEditDeleteSigner?document_id=${templateId}`,
        { 
        }
      );
      return response.data;
    },

    // fetch user profile details 
    getUserProfileData: async () => {
      const response = await axiosInstance.get(
        `/EsignServices/get-user-profile`,
      );
      return response.data;
    },

    // update user profile details 
    updateUserProfileData: async (body) => {
      const response = await axiosInstance.put(
        `/EsignServices/update-user-profile`,
        body
      );
      return response.data;
    },

    // update user profile picture 
    updateUserProfilePicture: async (body) => {
      const response = await axiosInstance.post(
        `/EsignServices/update-user-profile-picture`,
        body,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    },

    deleteFrequentSigner: async (signerID) => {
      const response = await axiosInstance.delete(
        `/EsignServices/AddEditDeleteFrequentSigner`,
        {
          data: { id: signerID },
        },
      );
      return response;
    },

    fetchfrequentSigner: async (searchText, page) => {
      const response = await axiosInstance.get(
        `/EsignServices/FetchFrequentSigner?searched_text=${searchText}&page=${page + 1}`,
        { 
        }
      );
      return response.data;
    },

    addSignerfromFrequent: async (frequentsignerID, documentID) => {
      const response = await axiosInstance.post(
        `/EsignServices/AddFrequentInSaveSigner`,
        { 
          ...frequentsignerID,
          document_id: documentID,
        },

      );
      return response.data;
    },

    scheduleInvite: async (data) => {
      const response = await axiosInstance.post(
        `/EsignServices/SetScheduleTimeAndReminder`,
        data,
        {
        },

      );
      return response.data;
    },
    
    requestForEsign: async (data) => {
      const response = await axiosInstance.post(
        `/EsignServices/NewRequestMultiSign`,
        data,
        {
        }

      );
      return response.data;
    },

    getAllSignerStatus: async (document_id, request_id) => {
      const response = await axiosInstance.get(
        `/EsignServices/FetchSignerStatus?document_id=${document_id}&request_id=${request_id}`,
        {
        }

      );
      return response.data;
    },

    getAllSentToEsignDocument: async (pageno, rowsPerPage, searchText) => {
      const response = await axiosInstance.post(
        `/EsignServices/NewGetEsignLog?page_num=${pageno}&row_per_page=${rowsPerPage}&searchText=${searchText}`,
        {
        }

      );
      return response.data;
    },
    getAllBulkDocuments: async (body) => {
      const response = await axiosInstance.post(
        `/EsignServices/GetAllBulkDocuments`,
        body
      );
      return response.data;
    },

    searchDocument: async (data) => {
      const response = await axiosInstance.post(
        `/EsignServices/NewGetEsignLogsearch`,
        data,
      );
      return response.data;
    },

    getAllEsignedDocument: async (pageno, rowsPerPage, searchText) => {
      const response = await axiosInstance.post(
        `/EsignServices/NewGetEsignLogReceived?page_no=${pageno}&row_per_page=${rowsPerPage}&searchText=${searchText}`,
        {
        }

      );
      return response.data;
    },

    getAllEsignedSearchDocument: async (searchtext) => {
      const response = await axiosInstance.post(
        `/EsignServices/NewGetEsignLogReceived?search_key=${searchtext}&fields=document_name,created_at`,
        {
        }

      );
      return response.data;
    },

    getTemplates: async () => {
      const response = await axiosInstance.get(
        `/EsignServices/GetStaticTemplateFromS3`,
        {
        }

      );
      return response.data;
    },

    cloneSignerWithRequestId: async (request_id, document_id) => {
      const response = await axiosInstance.post(
        `/EsignServices/CloneSignerWithRequestId`,
        {
          request_id,
          document_id,
        },
        {
          headers: {
            Authorization: `Bearer db1f5b8aa30d11efaa93c58cf55b45c8db1f5b8a`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    },

    checkPendingEsign: async (document_id) => {
      const response = await axiosInstance.post(
        `/EsignServices/CheckPendingEsign`,
        {
          document_id,
        },
      );
      return response.data;
    },

    expireLink: async (uuid_no) => {
      const response = await axiosInstance.post(
        `/EsignServices/link-expire`,
        {
          uuid_no
        },
      );
      return response.data;
    },

    sendReminder: async (uuid_no) => {
      const response = await axiosInstance.post(
        `/EsignServices/SendReminderEmail`,
        {
          uuid_no
        },
      );
      return response.data;
    },

    getEsignEmailTemplate: async () => {
      const response = await axiosInstance.get(
        `/EsignServices/GetAndUpdateEmailTemplatePremium`,
        {
        }

      );
      return response.data;
    },

    getSuperadminCreditsData: async (path ,body) => {
      const response = await axiosInstance.post(
        `/EsignServices/${path}`,
        body
      );
      return response.data;
    },
     // fetch saved signer details
    fetchKycCompanyMetaData: async () => {
      const response = await axiosInstance.get(`/EsignServices/SecureGenerateTokenAPI`);
      return response.data;
    },

    saveSignerCoordinates: async (payload, signature) => {
    const response = await axiosInstance.post(
      `/EsignServices/SaveSignersCoordinatesApi`,
      payload,
      signature
        ? {
            headers: {
              signature,
            },
          }
        : undefined,
    );
    return response.data;
  },

  fetchSignerCoordinatesList: async () => {
    const response = await axiosInstance.get(
      `/EsignServices/SaveSignersCoordinatesApi`,
      {},
    );
    return response.data;
  },

    fetchStampPapers: async (searchText, page, rowsPerPage, status) => {
      const response = await axiosInstance.post(
        `/EsignServices/StampAPI_get?searched_text=${searchText}&page=${page + 1}&page_size=${rowsPerPage}`,
        { status }
      );
      return response.data;
    },

    uploadCSV: async (payload) => {
      const response = await axiosInstance.post(
        `/EsignServices/importcsv`,
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    },

    uploadStamps: async (payload) => {
      const response = await axiosInstance.post(
        `/EsignServices/StampAPI_save`,
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    },

    getStampPaper: async () => {
      const response = await axiosInstance.get(
        `/EsignServices/StampAPI_get_for_assignment`,
        { 
        }
      );
      return response.data;
    },

    assignStampToDocument: async (payload) => {
      const response = await axiosInstance.post(
        `/EsignServices/StampAPI_get_for_assignment`,
        payload
      );
      return response.data;
    },

    deleteStamp: async (payload) => {
      const response = await axiosInstance.post(
        `/EsignServices/delete_Stamp`,
        payload
      );
      return response.data;
    },

    updateStampStatus: async (payload) => {
      const response = await axiosInstance.post(
        `/EsignServices/update_Stamp_status`,
        payload
      );
      return response.data;
    },

    setAutoReminder: async (payload) => {
      const response = await axiosInstance.post(
        `/EsignServices/set_auto_reminder`,
        payload
      );
      return response.data;
    },

  };
  
